
let abbreviation = ''
let name = ''
let zip1 = ''
let zip2 = ''
let address1 = ''
let address2 = ''
let address3 = ''
let tel1 = ''
let tel2 = ''
let tel3 = ''
let fax1 = ''
let fax2 = ''
let fax3 = ''
let detailsHtml = null
const PreferredDeliveryStorageKey = 'preferred_delivery_state'
const DetailSectionsDefaultStorageKey = 'detail_sections_default_values'
const DetailSectionsReturnStateKey = 'detail_sections_return_state'
var restoredFromBeforeHtml = false
const UnusableCharacters = [
  '①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫','⑬','⑭','⑮','⑯','⑰','⑱','⑲','⑳',
  'Ⅰ','Ⅱ', 'Ⅲ', 'Ⅳ', 'Ⅴ', 'Ⅵ', 'Ⅶ', 'Ⅷ', 'Ⅸ', 'Ⅹ', 'ⅰ', 'ⅱ', 'ⅲ', 'ⅳ', 'ⅴ', 'ⅵ', 'ⅶ', 'ⅷ', 'ⅸ', 'ⅹ',
  '㎜', '㎝', '㎞', '㎎', '㎏','㏄', '㍉','㌔', '㌢', '㍍', '㌘', '㌧', '㌃', '㌶', '㍑', '㍗', '㌍', '㌦', '㌣', '㌫',
  '№', '℡', '№', '㏍', '℡' ,'㊤', '㊥', '㊦', '㊧','㊨','㈱', '㈲','㈹', '㍾', '㍽', '㍼', '㍻', '≡', '∑', '∫',
  '纊', '鍈', '蓜', '炻', '棈', '兊', '夋', '奛', '奣', '寬', '﨑', '嵂', '咊', '咩', '哿', '喆', '坙', '坥', '垬', '埈'
]
const MaintenancePath = '/stock_maintenance'
window.MaintenancePath = MaintenancePath

$(document).on('turbolinks:load', function(){
  if(document.location.pathname.match(/^\/quotation_order\//)){
    if(document.location.pathname.match(/^\/quotation_order\/new/)){
      // 再見積遷移時は保存済みHTMLを使わず再見積用の初期化を行う
      var searchParams = new URLSearchParams(window.location.search)
      if (searchParams.has('saved_quotation_order_id')) {
        localStorage.removeItem('beforeHtml')
        localStorage.removeItem(DetailSectionsReturnStateKey)
      }

      restoreBeforeHtml()
      setJpostal()
      setQuotationDetailsActions($('.quotation_detail_table_item'))
    }
    if(document.location.pathname.match(/^\/quotation_order\/confirm/)){
      $('#confirm-form').on('submit', function(e){
        e.preventDefault()
        $('#cofirme-order').prop('disabled', true)
        this.submit()
      })
    }
    if(document.location.pathname.match(/^\/quotation_order\/complete/)){
      var beforeHtml = localStorage.getItem('beforeHtml')
      if (beforeHtml !== null){
        localStorage.removeItem('beforeHtml')
      }
      localStorage.removeItem(PreferredDeliveryStorageKey)
      localStorage.removeItem(DetailSectionsDefaultStorageKey)
    }

    // カレンダー
    $('.calender').daterangepicker({
      minDate: moment().startOf('day'),
      startDate: moment().startOf('day'),
      endDate: moment().startOf('day'),
      singleDatePicker: true,
      autoUpdateInput: false
    });
    $('.calender').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY/MM/DD'));
        setValue($(this))
        changeConfirmButtonDisabled()
        checkDate(this)
    });

    function checkDate(target){
      const format = /^\d{4}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])$/;
      var date = new Date($(target).val())
      if (isNaN(date)){
        addErrorMessage($(target), '正しい日付を入力してください')
        return;
      }else if (!format.test($(target).val())) {
        addErrorMessage($(target), '正しい形式の日付を入力してください')
        return;
      }
      var date = new Date($(target).val())
      var today = new Date()
      today.setHours(0, 0, 0, 0);

      if (date < today) {
        addErrorMessage($(target), '過去の日付は入力できません')
      }else{
        removeErrorMessage($(target))
      }
    }

    // 各種ボタン押下時のメンテナンス判定
    function get_maintenance_status(){
      var status = false
      $.ajax({
        type: 'GET',
        url: `/quotation_order/maintenance_status`,
        async: false
      }).done(function(json){
        status = json.is_maintenance
      }).fail(function(){
        status = false
      })
      return status
    }
    window.get_maintenance_status = get_maintenance_status

    function initForm(){
      // 特記事項の追加ボタンを押下した時
      $('#add_note').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        addNote()
      })

      // 納入先を選択した時
      // 納入先を編集ボタンを押下した時
      initDeliveryDestinationEvent()

      // 基本情報のフォームバリデーション
      setBasicInfoFormActions()
      // 概要のフォームバリデーション
      setOverViewFormActions()
      initPreferredDeliveryDateToggle()
      // 納入先のラジオボタンを選択した時
      $('input:radio[name="new_or_existing"]').on('change', function(e){
        deliveryDistinationRadioEvent(e.target)
      })

      // 納入先を新規作成ボタンを押下した時
      $('#save-new-delivery-destination').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        saveDeliveryDestination('納入先を登録しました')
      })

      // 納入先を編集保存ボタンを押下した時
      $('#save-existing-delivery-destination').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        saveDeliveryDestination('納入先を更新しました')
      })

      if ($('#delivery-destination-select').val() === '') {
        $('#edit-delivery-distination').prop('disabled', true)
        $('#edit-delivery-distination').hide()
        $('span.zip_address_text').hide()
      }

      $('#chancel-existing-delivery-destination').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        chancelEditDeliveryDestinationEvent()
      })

      // 表から選択モーダル内の選択ボタン
      $('#stock-list').find('.select-steel-pipe').on('click', function(e){
        e.preventDefault()
        selectListSteelPipe($(e.target))
      })

      // 商品選択モーダルの初期化（quotation_order_select_item.js）
      window.initSelectItemModal()

      $('#check_all').on('change', function(e){
        allChangeQuotationDetailCheck($(e.target).prop('checked'))
      })
      $('#delete-selected-detail').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        deleteSelectedDetails()
      })
      function navigateBackToInput(){
        var currentUrl = window.location.href;
        var newUrl = currentUrl.replace(/confirm/g, 'new');
        window.location.href = newUrl;
      }

      $('#back-to-input, #breadcrumb-back-to-input').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        navigateBackToInput()
      })
      $('#confirm_button').on('click', function(e){
        $('.detail-pipe-num-select').each(function() {
          var val = $(this).val();
          $(this).find('option').removeAttr('selected');
          $(this).find('option[value="' + val + '"]').attr('selected', 'selected');
        });
        var $clone = $('.content').clone();
        $clone.find('.select2-container').remove();
        $clone.find('select').removeClass('select2-hidden-accessible').removeAttr('data-select2-id aria-hidden tabindex');
        $clone.find('[data-select2-id]').removeAttr('data-select2-id');
        localStorage.setItem('beforeHtml', $clone.html())
        saveDetailSectionsReturnState()
      })
      $('#check_all').on('change', function(e){
        changeDeleteDetailsButtonDisabled()
      })

      createDetailTableObserver()

      initDetailSectionsToggle()

      setRequireFormEvent(document)

      changeConfirmButtonDisabled()
      changeDeleteDetailsButtonDisabled()
      changeStatusDeliveryDistinationForm('hide')
    }

    // ツールチップ(最近の履歴から商品を選ぶ）の初期化
    function initToolTips(){
      $('.item-history-button').each(function(index, element){
        setToolTipOption(element)

        $(element).on('click', function(e){
          if (get_maintenance_status()){
            window.location.href = MaintenancePath;
            return;
          }

          // 履歴から直接明細行に追加する
          var data = {
            item_name: $(element).data('item-name'),
            size_full: $(element).data('size-full'),
            length: $(element).data('length'),
            pipe_num: 1,
            steel_pipe_name: '',
            steel_pipe_type: $(element).data('steel-pipe-type'),
            row_num: $('.quotation_detail_table_item').length + 1,
            with_milsheet: $('#with_milsheet').prop('checked')
          }
          addQuotationDetail(data)
          $(e.target).tooltip('hide');
        })
      })
    }

    function setToolTipOption(element){
      $(element).tooltip({
        title: `品名規格名：${$(element).data('item-name')}<br>寸法：${$(element).data('size-full')}<br>長さ：${$(element).data('length')}`,
        html: true,
        template: '<div class="tooltip" role="tooltip" style="width: 200px;"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
      })
    }

    function setMaintenanceToolTip(){
      if ($('#maintenance').val() === 'false' ){
        window.changeSearchStockButtonDisabled()
        return;
      }
    }
    window.setMaintenanceToolTip = setMaintenanceToolTip

    function getMaintenanceStatus(){
      $.ajax({
        url: `/quotation_order/maintenance_status`,
        success: function(json, status, xhr) {
          $('#maintenance').val(json.is_maintenance.toString())
          setMaintenanceToolTip()
        },
        error: function(xhr, status, e){
          alert(status);
        }
      });
    }

    function setRequireFormEvent(target){
      $(target).find('.require').each(function(index,element){
        $(element).on('keyup change', function(e){
          changeConfirmButtonDisabled()
        })
      })
    }

    function changeConfirmButtonDisabled(){
      var is_empty_form = false
      var is_empty_detail = false
      var has_error = false
      var is_editing = $('#is_editing').val() === 'true'
      var detail_sections_opened = $('#detail_sections_opened').val() === 'true'
      var delivery_required = detail_sections_opened
      var delivery_value = $('#delivery-destination-select').val()

      $('.require').each(function(index, element){
        var $element = $(element)
        if ($element.is(':disabled')) { return true }
        if ($element.val() === '') { is_empty_form = true }
      })
      $('#quotation_detail_table_body').find('.length').each(function(index, element){
        if ($(element).val() === '') { is_empty_form = true }
      })
      $('#quotation_detail_table_body').find('.pipe-num').each(function(index, element){
        if ($(element).val() === '') { is_empty_form = true }
      })
      if ($('.quotation_detail_table_item').length === 0) { is_empty_detail = true }
      $('input').each(function(index, element){
        var $el = $(element)
        if ($el.hasClass('has-error') || $el.closest('.form-group').hasClass('has-error')) { has_error = true }
      })

      if (delivery_required && (!delivery_value || delivery_value === '')) {
        is_empty_form = true
      }

      if (delivery_required) {
        var preferredMode = $('input[name="preferred_delivery_date_mode"]:checked').val()
        if (!preferredMode) {
          is_empty_form = true
        } else if (preferredMode === 'specified') {
          var preferredDate = $('#over-view-preferred-delivery-date').val()
          if (!preferredDate) { is_empty_form = true }
        }
      }

      if (is_empty_form || has_error || is_empty_detail || is_editing) {
        $('#confirm_button').prop('disabled', true)
      }else{
        $('#confirm_button').prop('disabled', false)
      }
    }

    function setAccordionIconAnimation(){
      $(".accordion-button").click(function(){
        if($(this).hasClass("collapsed")){
          $(this).find('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
        }else{
          $(this).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-right');
        }
      });
    }

  var detailSectionsInitialValues = null
  var isRestoringDetailSections = false

    function initDetailSectionsToggle(){
      var toggleButton = $('#expand-detail-sections')
      var sections = $('#detail-sections')
      if (!toggleButton.length || !sections.length) { return }

      sections.hide()
      toggleButton.attr('aria-expanded', 'false').text('+')

      // 再見積時の見積依頼画面の任意入力欄は常に閉じる
      var searchParams = new URLSearchParams(window.location.search)
      var isRequote = searchParams.has('saved_quotation_order_id')
      var forceApplied = false

      if (isRequote) {
        sections.hide()
        toggleButton.attr('aria-expanded', 'false').text('+')
        resetDetailSectionsOpened()
        forceApplied = true
      }

      // デフォルト値（初期値）をローカルストレージに保持し、常に比較基準に使う
      var storedDefaults = loadDetailSectionsDefaults()
      if (!storedDefaults) {
        storedDefaults = collectDetailSectionsValues()
        saveDetailSectionsDefaults(storedDefaults)
      }
      var pristineDefaults = storedDefaults

      // 比較基準は常に pristineDefaults
      detailSectionsInitialValues = pristineDefaults

      // 戻り遷移時は UI 復元のみ行い、基準は変えない
      var restoredState = loadDetailSectionsReturnState()
      if (restoredFromBeforeHtml && restoredState) {
        // 一時的に復元値でフィールドを埋める
        var prevInitial = detailSectionsInitialValues
        detailSectionsInitialValues = restoredState.values || prevInitial
        applyDetailSectionsReturnState(restoredState)
        detailSectionsInitialValues = prevInitial
        clearDetailSectionsReturnState()
      } else if (!forceApplied) {
        // デフォルト値から変更されている場合は開いた状態で開始する
        if (hasChangedFromDefaults(storedDefaults)) {
          sections.show()
          toggleButton.attr('aria-expanded', 'true').text('−')
          markDetailSectionsOpened()
          changeConfirmButtonDisabled()
        }
      }

      toggleButton.off('click.detail-sections').on('click.detail-sections', function(e){
        e.preventDefault()
        toggleDetailSections()
      })
    }

    function hasChangedFromDefaults(defaultValues){
      // ストレージにデフォルトがない場合は従来のdefault属性判定で代替
      if (!defaultValues || !defaultValues.length) { return hasNonDefaultDetailSectionsByDefaultAttributes() }

      var currentValues = collectDetailSectionsValues()
      if (currentValues.length !== defaultValues.length) { return true }

      var defaultMap = mapValuesByKey(defaultValues)
      for (var i = 0; i < currentValues.length; i++) {
        var cur = currentValues[i]
        var defVal = defaultMap[cur.key]
        if (!defVal) { return true }
        if (!isSameFieldValue(defVal, cur)) { return true }
      }
      return false
    }

    function hasNonDefaultDetailSectionsByDefaultAttributes(){
      var sections = $('#detail-sections')
      var changed = false
      sections.find('input, select, textarea').each(function(_, el){
        var $el = $(el)

        if ($el.is(':checkbox, :radio')) {
          if ($el.prop('checked') !== $el.prop('defaultChecked')) { changed = true; return false }
        } else if ($el.is('select')) {
          var currentVal = $el.val() || ''
          var defaultVal = getSelectDefaultValue($el)
          if (currentVal !== defaultVal) { changed = true; return false }
        } else {
          var currentValText = $el.val() || ''
          var defaultValText = $el.prop('defaultValue') || ''
          if (currentValText !== defaultValText) { changed = true; return false }
        }
      })
      return changed
    }

    function getSelectDefaultValue($select){
      var defaultOption = $select.find('option').filter(function(){ return this.defaultSelected })
      if (defaultOption.length) { return defaultOption.val() || '' }
      // fallback: first option value
      var first = $select.find('option').first()
      return first.length ? (first.val() || '') : ''
    }

    function markDetailSectionsOpened(){
      $('#detail_sections_opened').val('true')
    }

    function resetDetailSectionsOpened(){
      $('#detail_sections_opened').val('false')
    }

    function toggleDetailSections(){
      var toggleButton = $('#expand-detail-sections')
      var sections = $('#detail-sections')
      if (!toggleButton.length || !sections.length) { return }

      if (sections.is(':visible')){
        var hasDiff = hasDetailSectionsDiff()
        if (hasDiff && !confirmCollapseDetailSections()) { return }
        toggleButton.attr('aria-expanded', 'false').text('+')

        if (hasDiff) {
          sections.stop(true, true).slideUp(function(){
            restoreDetailSectionsInitialValues()
          })
        } else {
          sections.stop(true, true).slideUp()
        }

        resetDetailSectionsOpened()
        changeConfirmButtonDisabled()
      }else{
        sections.stop(true, true).slideDown()
        toggleButton.attr('aria-expanded', 'true').text('−')
        markDetailSectionsOpened()
        changeConfirmButtonDisabled()
      }
    }

    function confirmCollapseDetailSections(){
      return window.confirm('概要・納入先の入力データがクリアされますが、続行してよろしいでしょうか？')
    }

    function hasDetailSectionsDiff(){
      var sections = $('#detail-sections')
      if (!sections.length) { return false }
      if (!detailSectionsInitialValues) { return false }

      var currentValues = collectDetailSectionsValues()
        if (currentValues.length !== detailSectionsInitialValues.length) {
          return true
        }

      var initialMap = mapValuesByKey(detailSectionsInitialValues)
      for (var i = 0; i < currentValues.length; i++) {
        var cur = currentValues[i]
        var key = cur.key
        var initVal = initialMap[key]
          if (!initVal) {
            return true
          }
          if (!isSameFieldValue(initVal, cur)) {
            return true
          }
      }
      return false
    }

    function restoreDetailSectionsInitialValues(){
      var sections = $('#detail-sections')
      if (!sections.length || !detailSectionsInitialValues) { return }

      isRestoringDetailSections = true

      var initialMap = mapValuesByKey(detailSectionsInitialValues)

      sections.find('input, select, textarea').each(function(_, el){
        var $el = $(el)
        var key = buildFieldKey($el)
        var initVal = initialMap[key]
        if (!initVal) { return true }

        if ($el.is(':checkbox') || $el.is(':radio')) {
          $el.prop('checked', !!initVal.checked)
          $el.trigger('change')
        } else {
          var restoredValue = (initVal.value == null ? '' : initVal.value)

          $el.val(restoredValue)
          $el.trigger('change')
        }
      })

      // ラジオボタンが同じ値の場合 change が発火しない対策で必ず発火させる(ボタンのhideとかに影響)
      var selectedRadio = sections.find('input[name="new_or_existing"]:checked').get(0)
      if (selectedRadio) {
        deliveryDistinationRadioEvent(selectedRadio)
      }

      isRestoringDetailSections = false
    }

    function collectDetailSectionsValues(){
      var sections = $('#detail-sections')
      if (!sections.length) { return [] }

      // 差分検知対象のみ収集
      var selectors = [
        '#over-view-title',
        'input[name="preferred_delivery_date_mode"]',
        '#over-view-preferred-delivery-date',
        'input[name="new_or_existing"]',
        '#delivery-destination-select',
        '#delivery_destination_code',
        '#destination_abbreviation',
        '#destination_name',
        '#destination_zip1',
        '#destination_zip2',
        '#destination_address1',
        '#destination_address2',
        '#destination_address3',
        '#destination_tel1',
        '#destination_tel2',
        '#destination_tel3',
        '#destination_fax1',
        '#destination_fax2',
        '#destination_fax3'
      ]

      var values = []
      var seenKeys = {}
      sections.find(selectors.join(',')).each(function(_, el){
        var $el = $(el)
        var key = buildFieldKey($el)
        if (seenKeys[key]) { return true }
        seenKeys[key] = true

        var isChoice = $el.is(':checkbox, :radio')
        var value = isChoice ? $el.is(':checked') : $el.val()
        var checked = isChoice ? $el.is(':checked') : undefined
        values.push({ key: key, value: value, checked: checked })
      })
      return values
    }

    function buildFieldKey($el){
      // 納入先コードは name が同じ hidden が複数存在するので、名前で固定キーにする
      var name = $el.attr('name') || ''
      if (name === 'delivery_destination[delivery_destination_code]') {
        return 'delivery_destination_code'
      }

      // name があればそれを優先、なければ id で同定
      var id = $el.attr('id') || ''

      // ラジオ/チェックボックスは value も含めて一意にする（同じ name を複数が共有するため）
      if ($el.is(':checkbox, :radio')) {
        var value = $el.val() || ''
        return [name, id, value].join('||')
      }

      return name + '||' + id
    }

    function mapValuesByKey(values){
      var map = {}
      values.forEach(function(v){ map[v.key] = v })
      return map
    }

    function isSameFieldValue(a, b){
      // チェックボックス/ラジオは checked の一致で判定（両者にcheckedがある場合のみ）
      var hasChecked = (typeof a.checked !== 'undefined') || (typeof b.checked !== 'undefined')
      if (hasChecked) {
        return !!a.checked === !!b.checked
      }
      // その他の値
      if (Array.isArray(a.value) || Array.isArray(b.value)) {
        var av = Array.isArray(a.value) ? a.value : [a.value]
        var bv = Array.isArray(b.value) ? b.value : [b.value]
        if (av.length !== bv.length) { return false }
        for (var i = 0; i < av.length; i++) {
          if (av[i] !== bv[i]) { return false }
        }
        return true
      }
      return (a.value || '') === (b.value || '')
    }

    function restoreBeforeHtml(){
      var beforeHtml = localStorage.getItem('beforeHtml')
      if (beforeHtml !== null){
        restoredFromBeforeHtml = true
        $('.content').html(beforeHtml)
        initSelect2()
        // initQuotationDetailForm()
        localStorage.removeItem('beforeHtml')
      }else{
        restoredFromBeforeHtml = false
      }
    }

      function saveDetailSectionsReturnState(){
        try {
          var state = {
            values: collectDetailSectionsValues(),
            opened: $('#detail_sections_opened').val() === 'true'
          }
          localStorage.setItem(DetailSectionsReturnStateKey, JSON.stringify(state))
        } catch(e) {}
      }

      function loadDetailSectionsReturnState(){
        try {
          var stored = localStorage.getItem(DetailSectionsReturnStateKey)
          return stored ? JSON.parse(stored) : null
        } catch(e){
          return null
        }
      }

      function clearDetailSectionsReturnState(){
        try { localStorage.removeItem(DetailSectionsReturnStateKey) } catch(e) {}
      }

    function applyDetailSectionsReturnState(state){
      var toggleButton = $('#expand-detail-sections')
      var sections = $('#detail-sections')
      if (!sections.length) { return }

      // 値を復元
      if (Array.isArray(state.values)) {
        detailSectionsInitialValues = state.values
        restoreDetailSectionsInitialValues()
      }

      // 開閉状態を復元
      if (state.opened) {
        sections.show()
        toggleButton.attr('aria-expanded', 'true').text('−')
        markDetailSectionsOpened()
      } else {
        sections.hide()
        toggleButton.attr('aria-expanded', 'false').text('+')
        resetDetailSectionsOpened()
      }
      changeConfirmButtonDisabled()
    }

    function loadDetailSectionsDefaults(){
      try {
        var stored = localStorage.getItem(DetailSectionsDefaultStorageKey)
        return stored ? JSON.parse(stored) : null
      } catch(e){
        return null
      }
    }

    function saveDetailSectionsDefaults(values){
      try {
        localStorage.setItem(DetailSectionsDefaultStorageKey, JSON.stringify(values))
      } catch(e){
        // noop
      }
    }

    function initSelect2(){
      window.initSelect2ForSelectItem();
    }

    function setValue(target){
      $(target).attr('value', target.val())
    }

// ==================基本情報で使用する関数ここから================================

    function setBasicInfoFormActions(){
      $('#over-view-name').on('keyup change', function(e){
        validateShiftJisForm($(e.target), 22, { useBytes: true })
        setValue($(e.target))
        changeConfirmButtonDisabled()
      })
    }

// ==================基本情報で使用する関数終わり================================

// ==================表から選択で使用する関数ここから================================

// 表から選択の鋼管モーダルから鋼管を選んだ際の処理
$(document).on('ajax:success', '.list-select-steel-pipe-form', function(event) {
  const [json, status, xhr] = event.detail;
  const contentType = xhr.getResponseHeader("content-type") || "";
  if (contentType.indexOf('html') > -1) {
    alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
    location.href = '/login';
  }
  if (contentType.indexOf('json') > -1) {
    // floatThead設定があれば解除
    if($('#stock-list').data('floatThead-attached')){
      $('#stock-list').floatThead('destroy');
    }

    $('#stock-list').html(json.list)
    $('#selected-steel-pipe-type').val(json.steel_pipe_type)
    $('#list-select').find('.item-name').text(json.item_text)
    $('#stock-list').find('.select-steel-pipe').on('click', function(e){
      e.preventDefault()
      selectListSteelPipe($(e.target))
    })
    fixedItemSelectTableHeader()
  }
  $(this).parents('.modal').modal('hide')
});
$(document).on('ajax:error', '.list-select-steel-pipe-form', function(event) {
  const [json, status, xhr] = event.detail;
  alert(status);
});

// 表から選択の選択ボタンを押下した際の処理
function selectListSteelPipe(target){
  // 表から選択で直接明細行に追加する
  var data = {
    item_name: target.data('item-name'),
    size_full: target.data('size-full'),
    length: target.data('length'),
    pipe_num: 1,
    steel_pipe_name: '',
    steel_pipe_type: target.data('steel-pipe-type'),
    row_num: $('.quotation_detail_table_item').length + 1,
    with_milsheet: $('#with_milsheet').prop('checked')
  }
  addQuotationDetail(data)
  target.parents('.modal').modal('hide')
}

function fixedItemSelectTableHeader(){
  let $table = $('#stock-list');

  $table.floatThead({
    scrollContainer: function ($table) {
      return $table.closest('.table-responsive'); // スクロールコンテナを指定
    }
  });
}

// ==================表から選択で使用する関数終わり================================

// ==================明細で使用する関数ここから================================

// 商品選択モーダルからのカスタムイベントを受け取って明細追加/編集
$(document).off('quotationOrder:itemSelected').on('quotationOrder:itemSelected', function(e, data){
  var editingRow = window.editingDetailRow();
  if (editingRow) {
    data.row_num = editingRow.find('.row_num_hidden').val();
    data.with_milsheet = editingRow.find('.with_milsheet').prop('checked');
  }
  addQuotationDetail(data)
})

function addQuotationDetail(data){
  // data が渡されない場合（旧来の直接呼び出し対応）
  if (!data) {
    var errors = window.stockSearchErrorMessage()
    if (errors.length > 0) {
      alert(errors.join("\n"))
      return false
    }
    data = {
      item_name: $('.item-name-hidden').val(),
      size_full: $('.size-full-select').val() || $('.size-full2-select').val(),
      length: window.getLengthValue(),
      pipe_num: $('#pipe_num').val(),
      steel_pipe_name: ($('.item-name-hidden').val() === '寸法から選択') ? $('.item-name-text-select').val() : '',
      steel_pipe_type: $('#selected-steel-pipe-type').val(),
      row_num: $('.quotation_detail_table_item').length + 1,
      with_milsheet: $('#with_milsheet').prop('checked')
    }
  }

  $.ajax({
    url: '/quotation_order/add_quotation_order_detail',
    type: 'post',
    data: {
      stock_search:{
        item_name: data.item_name,
        size_full: data.size_full,
        length: data.length,
        pipe_num: data.pipe_num,
        steel_pipe_name: data.steel_pipe_name
      },
      steel_pipe_type: data.steel_pipe_type,
      row_num: data.row_num,
      with_milsheet: data.with_milsheet
    },
    success: function(json, status, xhr) {
      const contentType = xhr.getResponseHeader("content-type") || "";
        if (contentType.indexOf('html') > -1) {
          alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
          location.href = '/login';
        }
        if (contentType.indexOf('json') > -1) {
          if (json.error) {
            alert(json.error);
            return false;
          }
          if ($('#quotation_detail_table_body').children().length < 30) {
            // 既存行を上書き、既存行が見つからなければ末尾に追加
            var addedElement = null;
            if (data && data.row_num) {
              var found = $('#quotation_detail_table_body').find('.row_num_hidden').filter(function(){ return $(this).val() == data.row_num; }).closest('.quotation_detail_table_item');
              if (found.length) {
                found.replaceWith(json.item);
                addedElement = $('#quotation_detail_table_body').find('.row_num_hidden').filter(function(){ return $(this).val() == data.row_num; }).closest('.quotation_detail_table_item');
              } else {
                $('#quotation_detail_table_body').append(json.item);
                addedElement = $('#quotation_detail_table_body').children().last();
              }
              // 編集時の参照はクリア
              window.clearEditingDetailRow();
            } else {
              $('#quotation_detail_table_body').append(json.item);
              addedElement = $('#quotation_detail_table_body').children().last();
            }
            setQuotationDetailsActions(addedElement)

            changeAddQuotationDetailButtonDisabled()
            changeConfirmButtonDisabled()
            setMaintenanceToolTip()
            applyQotationDetailRowNumber();
          }
      }
    },
    error: function(xhr, status, e) {
      alert(status);
    }
  });
}

function deleteQuotationDetail(target){
  target.closest('.quotation_detail_table_item').remove()
  changeAddQuotationDetailButtonDisabled()
  applyQotationDetailRowNumber()
  changeConfirmButtonDisabled()
  window.changeSearchStockButtonDisabled()
  setMaintenanceToolTip()
}

// 編集中の明細行を保持する変数
var editingDetailRow = null;

function editQuotationDetail(target){
  var item = target.closest('.quotation_detail_table_item')
  editingDetailRow = item;

  // 明細行の値を取得
  var itemName = item.find('.item_name_hidden').val()
  var sizeFull = item.find('.size-full-text2-hidden').val()
  var length = item.find('.length').val()
  var pipeNum = item.find('.pipe-num').val()
  var steelPipeType = item.find('.steel-pipe-type-hidden').val()
  var withMilsheet = item.find('.with_milsheet').prop('checked')
  var isCuttable = item.find('.is_cuttable-hidden').val()

  // カテゴリをセット
  var categoryVal = steelPipeType;
  var $categorySelect = $('.category-select');
  $categorySelect.val(categoryVal);

  // 品名一覧を取得してから値をセットする
  $.ajax({
    url: '/quotation_order/item_name_list',
    type: 'post',
    data: { steel_pipe_type: categoryVal },
    success: function(json) {
      var options = '<option value="">選択してください</option>';
      json.item_names.forEach(function(name) {
        options += '<option value="' + name + '">' + name + '</option>';
      });
      var $itemNameSelect = $('.item-name-text-select');
      if ($itemNameSelect.data('select2')) {
        $itemNameSelect.select2('destroy');
      }
      $itemNameSelect.html(options);
      $itemNameSelect.val(itemName);

      // 品名を選択した状態でsteel_pipe情報を取得
      $.ajax({
        url: '/stocks/steel_pipe',
        type: 'post',
        data: {
          item_name_text: itemName,
          steel_pipe_type: categoryVal
        },
        success: function(json2, status, xhr) {
          var contentType = xhr.getResponseHeader("content-type") || "";
          if (contentType.indexOf('json') > -1) {
            $('#selected-steel-pipe-cuttable').val(json2.steel_pipe_is_cuttable);
            window.setSteelPipeItem(json2);

            // 寸法をセット
            $('.size-full-select').val(sizeFull).trigger('change.select2');
            // A呼称を連動させる（change.select2では通常のchangeが発火しないため手動で連動）
            var selectedSizeFull = sizeFull;
            var $sizeFull2 = $('.size-full2-select');
            var currentSizeFullMap = json2.size_full_map || {};
            if (selectedSizeFull && currentSizeFullMap[selectedSizeFull] && currentSizeFullMap[selectedSizeFull].length > 0) {
              $sizeFull2.val(currentSizeFullMap[selectedSizeFull][0]).trigger('change.select2');
            }

            // 寸法選択後に長さを取得してセット
            $.ajax({
              url: '/stocks/steel_pipe_length',
              type: 'post',
              data: {
                item_name_text: itemName,
                size_full_text: sizeFull,
                steel_pipe_type: steelPipeType,
              },
              success: function(json3, status, xhr) {
                var contentType = xhr.getResponseHeader("content-type") || "";
                if (contentType.indexOf('json') > -1) {
                  // APIの応答に基づいてフォーム表示を切り替える
                  var actualCuttable = json3.is_cuttable;
                  if (actualCuttable) {
                    $('.length-select-form').hide();
                    $('.length-text-form').show();
                    var length_text_select = $('.length-text-select');
                    length_text_select.empty();
                    length_text_select.append(json3.lengths);
                    $('.length-text').val(length);
                    $('.enter_length_text').html('長さ入力可');
                    $('#selected-steel-pipe-max-length').val(json3.steel_pipe_max_length);
                  } else {
                    $('.length-select-form').show();
                    $('.length-text-form').hide();
                    $('.enter_length_text').html(null);
                    $('.length-select').html(json3.lengths);
                    window.reinitSelect2($('.length-select'), {placeholder: '選択してください', dropdownParent: $('#select-item-modal')});
                    $('select.select2.length-select').val(length).trigger('change.select2');
                  }
                }

                // 員数をセット
                var editPipeNum = pipeNum;

                window.changeSearchStockButtonDisabled();

                // モーダルを開く
                $('#select-item-modal').one('shown.bs.modal', function() {
                  // Select2初期化後に員数を再セット
                  var $pipeNum = $('#pipe_num');
                  if ($pipeNum.find('option[value="' + editPipeNum + '"]').length === 0) {
                    var newOption = new Option(editPipeNum, editPipeNum, true, true);
                    $pipeNum.append(newOption);
                  }
                  $pipeNum.val(editPipeNum).trigger('change');
                  window.changeSearchStockButtonDisabled();
                });
                $('#select-item-modal').modal('show');
              },
              error: function(xhr, status, e) {
                alert(status);
                // エラー時に編集ボタンを再有効化
                $('.edit-quotation-detail').prop('disabled', false);
                editingDetailRow = null;
              }
            });
          }
        },
        error: function(xhr, status, e) {
          alert(status);
          // エラー時に編集ボタンを再有効化
          $('.edit-quotation-detail').prop('disabled', false);
          editingDetailRow = null;
        }
      });
    },
    error: function(xhr, status, e) {
      alert(status);
      // エラー時に編集ボタンを再有効化
      $('.edit-quotation-detail').prop('disabled', false);
      editingDetailRow = null;
    }
  });
}
window.editingDetailRow = function() { return editingDetailRow; };
window.clearEditingDetailRow = function() { editingDetailRow = null; };

function copyQuotationDetail(target){
  origin = target.closest('.quotation_detail_table_item')
  var originPipeNum = origin.find('.pipe-num').val()

  // Select2が付与された員数をそのままcloneすると内部状態が壊れるため、
  // 一時的にDOMから切り離し、代わりにplaceholderを置いておく
  var pipeNumTd = origin.find('.detail-pipe-num-select').closest('td')
  var placeholder = $('<td class="pipe-num-placeholder"></td>')
  pipeNumTd.after(placeholder)
  pipeNumTd.detach()

  // 員数を除いた状態で行をコピーする
  copy = origin.clone(false)

  // 切り離していた員数を元の行に戻す
  placeholder.after(pipeNumTd)
  placeholder.remove()

  // コピー行用に新しい員数selectを作成し、placeholderの位置に差し込む
  var newPipeNumTd = $('<td></td>')
  var newSelect = $('<select class="form-control pipe-num detail-pipe-num-select require_input" data-param-name="pipe_num"></select>')
  for (var i = 1; i <= 100; i++) {
    newSelect.append($('<option></option>').val(i.toString()).text(i.toString()))
  }
  // 101以上の員数の場合、オプションに追加してからセットする
  var originNum = parseInt(originPipeNum, 10);
  if (originNum > 100) {
    newSelect.append($('<option></option>').val(originPipeNum).text(originPipeNum));
  }
  newSelect.val(originPipeNum)
  newPipeNumTd.append(newSelect)
  copy.find('.pipe-num-placeholder').replaceWith(newPipeNumTd)

  copy.find('.detail-size-full-select').val(origin.find('.detail-size-full-select').val())
  copy.find('.length').val(origin.find('.length').val())
  $('#quotation_detail_table_body').append(copy);

  setQuotationDetailsActions(copy)

  changeAddQuotationDetailButtonDisabled()
  applyQotationDetailRowNumber()
  changeConfirmButtonDisabled()
  window.changeSearchStockButtonDisabled()
  setMaintenanceToolTip()
}

function applyQotationDetailRowNumber() {
  $('.row_num').each(function(i){
    $(this).text(i+1);
    $(this).parent().find('.row_num_hidden').val(i+1);

    $(this).parent().find('.require_input').each(function(){
      param_name = $(this).data('param-name')
      $(this).attr('name', `quotation_order_details[${i+1}][${param_name}]`)
    })
  });
  changeAddQuotationDetailButtonDisabled()
}

function allChangeQuotationDetailCheck(value){
  $('.select_check').each(function(){
    $(this).prop('checked', value)
  })
}

function deleteSelectedDetails(){
  $('.select_check').each(function(){
    if ($(this).prop('checked')) {
      $(this).closest('.quotation_detail_table_item').remove()
    }
  })
  applyQotationDetailRowNumber()
  changeConfirmButtonDisabled()
  window.changeSearchStockButtonDisabled()
  setMaintenanceToolTip()
}

function deleteAllDetails(){
  $('.quotation_detail_table_item').remove()
  $('#delete-all-detail').prop('disabled', true)
  changeConfirmButtonDisabled()
}

$('#delete-all-detail').on('click', function(){
  if (get_maintenance_status()){
    window.location.href = MaintenancePath;
    return false;
  }

  if ($('.quotation_detail_table_item').length == 0) {
    alert('明細がありません。');
    return false;
  }
  $('#delete-modal').modal();
  return false;
});

$('#delete_all_details').on('click', function(){
  deleteAllDetails();
  window.changeSearchStockButtonDisabled()
  setMaintenanceToolTip()
  $('#delete-modal').modal('hide');
})


function updateQuotationDetail(e){
  var item = $(e.target).closest('.quotation_detail_table_item')

  var row_num = item.find('.row_num_hidden').val()
  var category_text = item.find('.category_text_hidden').val()
  var item_name = item.find('.item_name_hidden').val()
  var size_full = item.find('.size-full-text2-hidden').val()
  var length = item.find('.length').val()
  var pipe_num = item.find('.pipe-num').val()
  var with_milsheet = item.find('.with_milsheet').prop('checked')

  $.ajax({
    url: '/quotation_order/update_quotation_order_detail',
    type: 'post',
    data: {
      stock_search:{
        item_name: item_name,
        size_full: size_full,
        length: length,
        pipe_num: pipe_num,
      },
      steel_pipe_type: item.find('.steel-pipe-type-hidden').val(),
      row_num: row_num,
      with_milsheet: with_milsheet
    },
    success: function(json, status, xhr) {
      const contentType = xhr.getResponseHeader("content-type") || "";
        if (contentType.indexOf('html') > -1) {
          alert('無操作状態から一定時間が経過したため、自動的にログアウトされました。\n再度ログインしてください。');
          location.href = '/login';
        }
        if (contentType.indexOf('json') > -1) {
          if (json.error) {
            alert(json.error);
            return false;
          }
          if (Number.isInteger(json.total_weight)) {
            total_weight = json.total_weight.toFixed(1)
          }else{
            total_weight = json.total_weight
          }
          item.find('.total_weight').text(total_weight);
          item.find('.stock_condition').text(json.stock_condition);
          item.find('.unit_price').text(json.unit_price);
      }
    },
    error: function(xhr, status, e) {
      alert(status);
    }
  });
}

// 明細行の員数Select2を初期化する
function initDetailPipeNumSelect2($select) {
  if ($select.data('select2')) {
    $select.select2('destroy');
  }
  $select.siblings('.select2-container').remove();
  $select.select2({
    tags: true,
    width: '100%',
    createTag: function(params) {
      var term = $.trim(params.term);
      if (term === '' || !/^\d+$/.test(term)) return null;
      var num = parseInt(term, 10);
      if (num < 1 || num > 9999) return null;
      var normalized = num.toString();
      return { id: normalized, text: normalized };
    },
    matcher: function(params, data) {
      if ($.trim(params.term) === '') return data;
      if (data.text.indexOf($.trim(params.term)) === 0) return data;
      return null;
    }
  });
}

function changeAddQuotationDetailButtonDisabled(){
  if($('.quotation_detail_table_item').length >= 30){
    $('.add-quotation-detail').prop('disabled', true)
    $('.copy-quotation-detail').prop('disabled', true)
  }else{
    $('.add-quotation-detail').prop('disabled', false)
    $('.copy-quotation-detail').prop('disabled', false)
  }
}
window.changeAddQuotationDetailButtonDisabled = changeAddQuotationDetailButtonDisabled

function setQuotationDetailsActions(details){
  details.each(function(index, detail){
    $(detail).find('.delete-quotation-detail').on('click', function(e){
      e.preventDefault()
      if (get_maintenance_status()){
        window.location.href = MaintenancePath;
        return;
      }

      deleteQuotationDetail($(e.target))
    })
    $(detail).find('.edit-quotation-detail').on('click', function(e){
      e.preventDefault()
      if (get_maintenance_status()){
        window.location.href = MaintenancePath;
        return;
      }

      // 編集ボタンを無効化
      var $btn = $(e.target);
      if ($btn.prop('disabled')) return;
      $btn.prop('disabled', true);

      editQuotationDetail($btn)
    })
    $(detail).find('.copy-quotation-detail').on('click', function(e){
      e.preventDefault()
      if (get_maintenance_status()){
        window.location.href = MaintenancePath;
        return;
      }

      copyQuotationDetail($(e.target))
    })
    $(detail).find('.select_check').on('change', function(e){
      e.preventDefault()
      changeDeleteDetailsButtonDisabled()
    })
    initDetailPipeNumSelect2($(detail).find('.detail-pipe-num-select'))
    $(detail).find('.pipe-num').on('change', function(e){
      $(e.target).attr('value', e.target.value)
      changeConfirmButtonDisabled()
      // 員数変更時に総重量・在庫状況・単価を自動再計算
      updateQuotationDetail(e)
    })
    $(detail).find('.with_milsheet').on('change', function(e){
      e.preventDefault()
      $(e.target).attr('checked', $(e.target).prop('checked'))
    })
  })
}

function changeDeleteDetailsButtonDisabled(){
  if ($('.select_check:checked').length > 0) {
    $('#delete-selected-detail').prop('disabled', false)
  }else{
    $('#delete-selected-detail').prop('disabled', true)
  }

  if ($('.quotation_detail_table_item').length > 0) {
    $('#delete-all-detail').prop('disabled', false)
  }else{
    $('#delete-all-detail').prop('disabled', true)
  }
}

function createDetailTableObserver(){
  if (document.getElementById('quotation_detail_table_body') == null) { return }
  const callBack = function(mutationsList, observer) {
    changeDeleteDetailsButtonDisabled()
  }

  const observer = new MutationObserver(callBack);

  const config = { attributes: true, childList: true, subtree: true };

  observer.observe(document.getElementById('quotation_detail_table_body'), config);
}

// ==================明細で使用する関数終わり================================

// ==================特記事項で使用する関数ここから================================

    function bindNoteFieldEvents(elements){
      elements.on('keyup change', function(e){
        validateShiftJisForm($(e.target), 62, { useBytes: true })
        setValue($(e.target))
        changeConfirmButtonDisabled()
      })
    }

    // 特記事項を追加（最大6件）
    function addNote(){
      var length = $('#notes').children('.row').length
      row = $('#notes').children('.row:first').clone()
      row.find('#add_note').remove()
      var circledDigits = ['①', '②', '③', '④', '⑤', '⑥']
      var labelText = circledDigits[length] || `特記事項${length + 1}`
      row.find('.control-label').text(labelText)

      row.find('.form-control').attr('name', `over_view[note${length + 1}]`)
      row.find('.form-control').attr('id', `over_view_note${length + 1}`)
      // 既存の値と value 属性を空にして、復元時に複製元の値が入らないようにする
      row.find('.form-control').val('')
      row.find('.form-control').attr('value', '')
      removeErrorMessage(row.find('.form-control'))
      bindNoteFieldEvents(row.find('.over-view-note'))

      $('#notes').append(row)

      var afterLength = $('#notes').children('.row').length
      if (afterLength >= 6) {
        $('#add_note').prop('disabled', true)
        return;
      }
    }

// ==================特記事項で使用する関数終わり================================

// ==================概要部分で使用する関数ここから================================

    function setOverViewFormActions(){
      $('#over-view-title').on('keyup change', function(e){
        validateShiftJisForm($(e.target), 40, { useBytes: true })
        setValue($(e.target))
        changeConfirmButtonDisabled()
      })
      $('#over-view-preferred-delivery-date').on('keyup change', function(e){
        validateShiftJisForm($(e.target), 8)
        setValue($(e.target))
        checkDate(e.target)
        changeConfirmButtonDisabled()
      })
      bindNoteFieldEvents($('.over-view-note'))
    }

    function initPreferredDeliveryDateToggle(){
      var $radios = $('input.preferred-delivery-date-toggle')
      var $input = $('#over-view-preferred-delivery-date')
      if (!$radios.length || !$input.length) { return }

      // 復元は confirm から戻ったときのみ。それ以外はストレージをクリアしてデフォルト(未定)にする
      if (restoredFromBeforeHtml) {
        loadPreferredDeliveryState()
      } else {
        clearPreferredDeliveryState()
      }

      function updatePreferredDeliveryDateState(){
        var selectedMode = $radios.filter(':checked').val()
        var isSpecified = selectedMode === 'specified'
        var $container = $input.closest('.preferred-delivery-date-input')

        $input.prop('disabled', !isSpecified)
        $container.toggleClass('is-disabled', !isSpecified)

        if (!isSpecified) {
          removeErrorMessage($input)
        }
      }

      $radios.off('change.preferred-delivery').on('change.preferred-delivery', function(){
        updatePreferredDeliveryDateState()
        changeConfirmButtonDisabled()
        savePreferredDeliveryState()
      })

      updatePreferredDeliveryDateState()
      savePreferredDeliveryState()
    }

    function savePreferredDeliveryState(){
      try {
        var mode = $('input.preferred-delivery-date-toggle:checked').val()
        var payload = { mode: mode, ts: new Date().toISOString() }
        localStorage.setItem(PreferredDeliveryStorageKey, JSON.stringify(payload))
      } catch (e) {}
    }

    function loadPreferredDeliveryState(){
      try {
        var stored = JSON.parse(localStorage.getItem(PreferredDeliveryStorageKey))
        if (!stored) { return }
        var mode = stored.mode
        if (mode) {
          $('input.preferred-delivery-date-toggle').prop('checked', false)
          $('input.preferred-delivery-date-toggle[value="' + mode + '"]').prop('checked', true)
        }
      } catch (e) {}
    }

    function clearPreferredDeliveryState(){
      try { localStorage.removeItem(PreferredDeliveryStorageKey) } catch (e) {}
    }

// ==================概要部分で使用する関数終わり================================

// ==================納入先部分で使用する関数ここから================================

    // 住所自動入力のイベントを登録
    function setJpostal(){
      $('#destination_zip1').jpostal({
        postcode : [
          '#destination_zip1',
          '#destination_zip2'
        ],
        address : {
          "#destination_address1" : "%3%4%5"
        }
      })
    }

    // 納入先のラジオボタンを選択した時の処理
    function deliveryDistinationRadioEvent(target){
      value = $(target).val()

      // 詳細セクションの復元中は入力値を上書きしないよう、UI状態の調整だけ行う
      if (isRestoringDetailSections) {
        $('#delivery-destination-select').attr('disabled', false)
        // 編集中フラグなどをリセットするため、ラジオのdisableも解除しておく
        $('input[name="new_or_existing"]').prop('disabled', false)
        $('#delivery-destination-form').find('input').prop('disabled', true)
        if ($('#delivery-destination-select').val() !== ''){
          $('#edit-delivery-distination').show()
          $('span.zip_address_text').show()
        } else {
          $('#edit-delivery-distination').hide()
          $('span.zip_address_text').hide()
        }
        $('#new-delivery-destination-form-buttons').hide()
        $('#existing-delivery-destination-form-buttons').hide()
        $('#is_editing').val('false')
        changeStatusDeliveryDistinationForm('hide')
        submittableSaveButton()
        changeConfirmButtonDisabled()
        return
      }

      if (value == 'existing') {
        restoreDeliveryDestinationParam()
        $('#delivery-destination-select').attr('disabled', false)
        $('#delivery-destination-form').find('input').prop('disabled', true)
        if ($('#delivery-destination-select').val() !== ''){
          $('#edit-delivery-distination').show()
          $('span.zip_address_text').show()
          deliveryDestinationSelectEvent($('#delivery-destination-select'))
        }
        $.each($('#delivery-destination-form').find('input'), function(index, element){
          // $(element).trigger('keyup')
          removeErrorMessage($(element))
        })
        $('#new-delivery-destination-form-buttons').hide()
        $('#is_editing').val('false')
        changeStatusDeliveryDistinationForm('hide')
      } else {
        tempDeliveryDestinationParams()
        $('#delivery-destination-select').attr('disabled', true)
        $('#edit-delivery-distination').hide()
        $('span.zip_address_text').hide()

        $('#delivery-destination-form').find('input').prop('disabled', false)
        $('#delivery-destination-form').find('input').val('')
        $.each($('#delivery-destination-form').find('input'), function(index, element){
          removeErrorMessage($(element))
        })
        $('#existing-delivery-destination-form-buttons').hide()
        $('#new-delivery-destination-form-buttons').show()
        $('#is_editing').val('true')
        changeStatusDeliveryDistinationForm('show')
      }
      submittableSaveButton()
      changeConfirmButtonDisabled()
    }

    // 納入先を選択した時の処理
    function deliveryDestinationSelectEvent(target){
      id = $(target).val()

      if (id === '') {
        $('#edit-delivery-distination').prop('disabled', true)
        $('#edit-delivery-distination').hide()
        $('span.zip_address_text').hide()
        $('#delivery-destination-form').find('input').val('')
        $('input[name="delivery_destination[delivery_destination_code]"]').val('')
        changeConfirmButtonDisabled()
        return;
      }
      $.ajax({
        url: `/quotation_order/delivery_destination?id=${id}`,
        success: function(html, status, xhr) {
          if (isLoginPageHtml(html)) {
            window.location.href = '/login'
            return
          }
          $('#delivery-destination-form').replaceWith(html)
          initDeliveryDestinationEvent()
          changeConfirmButtonDisabled()
          setRequireFormEvent($('#delivery-destination-form'))
          setJpostal()
          changeConfirmButtonDisabled()
          changeStatusDeliveryDistinationForm('hide')

          updateEditDeliveryDistinationState()
        },
        error: function(xhr, status, e){
          if (xhr && xhr.status === 401) {
            window.location.href = '/login'
            return
          }
          alert(status);
        }
      });
    }

    function isLoginPageHtml(html){
      if (typeof html !== 'string') { return false }
      // login page has .login-box wrapper; use a simple substring check
      return html.indexOf('login-box') !== -1 || html.indexOf('login-box-body') !== -1
    }

    function shouldDisableEditDeliveryDistination(){
      var $select = $('#delivery-destination-select')
      if (!$select.length) { return false }
      var val = $select.val()
      if (!val) { return false }
      var name = ($select.find('option:selected').data('name') || $select.find('option:selected').text() || '').trim()
      return name === '（お客様引取）' || name === '（その他：特記参照）'
    }

    function updateEditDeliveryDistinationState(){
      var $btn = $('#edit-delivery-distination')
      if (!$btn.length) { return }

      if (shouldDisableEditDeliveryDistination()) {
        $btn.prop('disabled', true)
      } else {
        $btn.prop('disabled', false)
      }
    }

    function changeStatusDeliveryDistinationForm(status){
      if (status === 'hide'){
        $('#delivery-destination-form-fields').hide()
      }else if (status === 'show'){
        $('#delivery-destination-form-fields').show()
      }
    }

    // 納入先の保存のリクエストを行う
    function saveDeliveryDestination(message){
      $.ajax({
        url: '/quotation_order/create_delivery_destination',
        type: 'post',
        data: deliveryDestinationParams(),
        success: function(html, status, xhr) {
          alert(message)
          $('#delivery-destination-form').replaceWith(html)
          initDeliveryDestinationEvent()
          $('#existing-delivery-destination-form-buttons').hide()
          $('#new-delivery-destination-form-buttons').hide()
          $('input[name="new_or_existing"][value="existing"]').prop('checked', true)
          $('input[name="new_or_existing"]').prop('disabled', false)
          $('#edit-delivery-distination').prop('disabled', false)
          setJpostal()
          $('#is_editing').val('false')
          changeConfirmButtonDisabled()
          changeStatusDeliveryDistinationForm('hide')
        },
        error: function(xhr, status, e){
          alert(status);
        }
      });
    }

    function deliveryDestinationParams(){
      var $selectedOption = $('#delivery-destination-select').find('option:selected')
      var deliveryCode = ''
      var isNewDelivery = $('input[name="new_or_existing"]:checked').val() === 'new'
      if ($selectedOption.length) {
        deliveryCode = $selectedOption.data('deliveryDestinationCode') ||
                       $selectedOption.data('delivery-destination-code') ||
                       $selectedOption.data('delivery_destination_code') || ''
      }

      if (!deliveryCode) {
        var $codeInputs = $('input[name="delivery_destination[delivery_destination_code]"]')
        if ($codeInputs.length) {
          deliveryCode = $codeInputs.last().val() || ''
        }
      }

      if (isNewDelivery) {
        deliveryCode = ''
      }

      return {
        delivery_destination: {
          abbreviation: $('#destination_abbreviation').val(),
          name: $('#destination_name').val(),
          zip1: $('#destination_zip1').val(),
          zip2: $('#destination_zip2').val(),
          address1: $('#destination_address1').val(),
          address2: $('#destination_address2').val(),
          address3: $('#destination_address3').val(),
          tel1: $('#destination_tel1').val(),
          tel2: $('#destination_tel2').val(),
          tel3: $('#destination_tel3').val(),
          fax1: $('#destination_fax1').val(),
          fax2: $('#destination_fax2').val(),
          fax3: $('#destination_fax3').val(),
          delivery_destination_code: deliveryCode
        }
      }
    }

    // 納入先を編集ボタンを押下した時の処理を登録
    function setEditDeliveryDistinationButtonEvent(){
      $('#edit-delivery-distination').on('click', function(e){
        e.preventDefault()
        if (get_maintenance_status()){
          window.location.href = MaintenancePath;
          return;
        }

        tempDeliveryDestinationParams()
        submittableSaveButton()
        $('#delivery-destination-form-fields').find('input').prop('disabled', false)
        $('#delivery-destination-select').prop('disabled', true)
        $('input[name="new_or_existing"]').prop('disabled', true)
        $('#edit-delivery-distination').prop('disabled', true)
        $('#existing-delivery-destination-form-buttons').show()
        $('#is_editing').val('true')
        $('span.zip_address_text').hide()

        changeConfirmButtonDisabled()
        changeStatusDeliveryDistinationForm('show')
      })
    }

    function setDeliveryDestinationSelectEvent(){
      $('#delivery-destination-select').on('change', function(e){
        deliveryDestinationSelectEvent(e.target)
      })
    }

    function chancelEditDeliveryDestinationEvent(){
      restoreDeliveryDestinationParam()
      $('#delivery-destination-form-fields').find('input').prop('disabled', true)
      $('#delivery-destination-select').prop('disabled', false)
      $('input[name="new_or_existing"]').prop('disabled', false)
      $('#edit-delivery-distination').prop('disabled', false)
      $('#existing-delivery-destination-form-buttons').hide()
      $('#is_editing').val('false')
      $('span.zip_address_text').show()
      changeConfirmButtonDisabled()
      changeStatusDeliveryDistinationForm('hide')
    }

    function tempDeliveryDestinationParams(){
      abbreviation = $('#destination_abbreviation').val()
      name = $('#destination_name').val()
      zip1 = $('#destination_zip1').val()
      zip2 = $('#destination_zip2').val()
      address1 = $('#destination_address1').val()
      address2 = $('#destination_address2').val()
      address3 = $('#destination_address3').val()
      tel1 = $('#destination_tel1').val()
      tel2 = $('#destination_tel2').val()
      tel3 = $('#destination_tel3').val()
      fax1 = $('#destination_fax1').val()
      fax2 = $('#destination_fax2').val()
      fax3 = $('#destination_fax3').val()
    }

    function restoreDeliveryDestinationParam(){
      $('#destination_abbreviation').val(abbreviation)
      $('#destination_name').val(name)
      $('#destination_zip1').val(zip1)
      $('#destination_zip2').val(zip2)
      $('#destination_address1').val(address1)
      $('#destination_address2').val(address2)
      $('#destination_address3').val(address3)
      $('#destination_tel1').val(tel1)
      $('#destination_tel2').val(tel2)
      $('#destination_tel3').val(tel3)
      $('#destination_fax1').val(fax1)
      $('#destination_fax2').val(fax2)
      $('#destination_fax3').val(fax3)

      $.each($('#delivery-destination-form-fields').find('input'), function(index, element){
        removeErrorMessage($(element))
      })
    }

    //  =========納入先バリデーションここから=================
    function validateGroupForm(targets){
      var is_length_invalid = false
      var is_unusable_character_invalid = false

      $.each(targets, function (index, hash) {
        var $target = hash.target
        if (!$target || !$target.length) { return }

        var value = $target.val() || ''
        var limit = hash.maxLength

        if (hash.is_required && value === '') {
          return
        }

        if (typeof limit === 'number' && value.length > limit) {
          is_length_invalid = true
        } else if (includeUnusableCharacters(value)) {
          is_unusable_character_invalid = true
        }
      });

      if (is_length_invalid) {
        $.each(targets, function (index, hash) {
          addErrorMessage(hash.target, '入力した文字が長すぎます。')
        });
      } else if (is_unusable_character_invalid) {
        $.each(targets, function (index, hash) {
          addErrorMessage(hash.target, '入力した文字は使用できません。')
        });
      } else {
        $.each(targets, function (index, hash) {
          removeErrorMessage(hash.target)
        });
      }

      submittableSaveButton()
    }

    function setDeliveryDestinationValidations(){
      var zip_targets = [{target: $('#destination_zip1'), maxLength: 3, is_required: true}, {target: $('#destination_zip2'), maxLength: 4, is_required: true}]
      var address_targets = [
        {target: $('#destination_address1'), maxLength: 40, is_required: true},
        {target: $('#destination_address2'), maxLength: 20, is_required: true}
      ]
      var tel_targets = [{target: $('#destination_tel1'), maxLength: 5, is_required: true}, {target: $('#destination_tel2'), maxLength: 5, is_required: true}, {target: $('#destination_tel3'), maxLength: 5, is_required: true}]
      var fax_targets = [{target: $('#destination_fax1'), maxLength: 5, is_required: false}, {target: $('#destination_fax2'), maxLength: 5, is_required: false}, {target: $('#destination_fax3'), maxLength: 5, is_required: false}]
      $('#destination_zip1,#destination_zip2,#destination_tel1,#destination_tel2,#destination_tel3,#destination_fax1,#destination_fax2,#destination_fax3').on('input', function(e){
        replaceFullWidthChar($(e.target))
      })

      $('#destination_abbreviation').on('keyup change', function(e){
        validateShiftJisForm($(e.target), 20)
      })
      $('#destination_name').on('keyup change', function(e){
        replaceCharacter($(e.target))
        validateShiftJisForm($(e.target), 25)
      })
      $('#destination_zip1').on('keyup change', function(e){
        validateGroupForm(zip_targets)
      })
      $('#destination_zip2').on('keyup change', function(e){
        validateGroupForm(zip_targets)
      })
      $('#destination_address1').on('keyup change', function(e){
        replaceCharacter($(e.target))
        validateGroupForm(address_targets)
      })
      $('#destination_address2').on('keyup change', function(e){
        replaceCharacter($(e.target))
        validateGroupForm(address_targets)
      })
      $('#destination_address3').on('keyup change', function(e){
        replaceCharacter($(e.target))
        validateShiftJisForm($(e.target), 60)
      })
      $('#destination_tel1').on('keyup change', function(e){
        validateGroupForm(tel_targets)
      })
      $('#destination_tel2').on('keyup change', function(e){
        validateGroupForm(tel_targets)
      })
      $('#destination_tel3').on('keyup change', function(e){
        validateGroupForm(tel_targets)
      })
      $('#destination_fax1').on('keyup change', function(e){
        validateGroupForm(fax_targets)
      })
      $('#destination_fax2').on('keyup change', function(e){
        validateGroupForm(fax_targets)
      })
      $('#destination_fax3').on('keyup change', function(e){
        validateGroupForm(fax_targets)
      })
    }
    //  =========納入先バリデーションここまで=================

    function initDeliveryDestinationEvent(){
      setEditDeliveryDistinationButtonEvent()
      setDeliveryDestinationSelectEvent()
      setDeliveryDestinationValidations()
    }

    function syncAddressLabelErrorState(){
      var $addressGroup = $('#destination_address1').closest('.form-group')
      if (!$addressGroup.length) { return }

      var $address3Group = $('#destination_address3').closest('.form-group')

      var hasAddressError = $('#destination_address1, #destination_address2, #destination_address3').toArray().some(function(element){
        var $element = $(element)
        if (!$element.length) { return false }
        if ($element.hasClass('has-error')) { return true }
        return $element.closest('.form-group').find('.error_message').length > 0
      })

      if (hasAddressError) {
        $addressGroup.addClass('has-error')
        if ($address3Group.length) { $address3Group.addClass('has-error') }
      } else {
        $addressGroup.removeClass('has-error')
        if ($address3Group.length) { $address3Group.removeClass('has-error') }
      }
    }

    // 半角文字を全角文字に変換する
    function replaceCharacter(target) {
      value = target.val()
      if (typeof value !== 'string') { return }

      replace_value = String(value).replace(/[!-~]/g, function(all) {
        return String.fromCharCode(all.charCodeAt(0) + 0xFEE0);
      });

      target.val(replace_value)
    };

    // 全角文字を半角文字に変換する
    function replaceFullWidthChar(target) {
      value = target.val()
      if (typeof value !== 'string') { return }

      replace_value = String(value).replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(all) {
        return String.fromCharCode(all.charCodeAt(0) - 0xFEE0);
      });

      target.val(replace_value)
    };

    function submittableSaveButton(){
      targets = $('#delivery-destination-form-fields').find('input')

      is_valid = false
      $.each(targets, function (index, target) {
        if (($(target).data('required') == true && $(target).val() == '') || $(target).closest('.form-group').find('.error_message').length > 0){
          is_valid = true
        }
      });

      var tel_inputs = [$('#destination_tel1'),$('#destination_tel2'),$('#destination_tel3')]
      var fax_inputs = [$('#destination_fax1'),$('#destination_fax2'),$('#destination_fax3')]

      if (!(isAllEmptyValue(tel_inputs) || isAllFilledValue(tel_inputs))) {
        is_valid = true
      }
      if (!(isAllEmptyValue(fax_inputs) || isAllFilledValue(fax_inputs))) {
        is_valid = true
      }

      if (is_valid) {
        $('#save-existing-delivery-destination').attr('disabled', true)
        $('#save-new-delivery-destination').attr('disabled', true)
      }
      else{
        $('#save-existing-delivery-destination').attr('disabled', false)
        $('#save-new-delivery-destination').attr('disabled', false)
      }
    }

    function isAllEmptyValue(inputs){
      return inputs.every(input => input.val() === '')
    }

    function isAllFilledValue(inputs){
      return inputs.every(input => input.val() !== '')
    }

// ==================納入先部分で使用する関数終わり================================

// ==================共通バリデーションで使用する関数ここから================================

    function addErrorMessage(target, message){
      if (!target || !target.length) { return }

      var error_message_element = $('<p class="error_message">').text(message);
      var $formGroup = target.closest('.form-group');

      target.addClass('has-error')
      $formGroup.addClass('has-error')

      var error_message_area = $formGroup.find('.error_message_area')
      if (error_message_area.contents().length == 0) {
        error_message_area.append(error_message_element);
      }else{
        error_message_area.contents().replaceWith(error_message_element);
      }

      syncAddressLabelErrorState()
    }
    window.addErrorMessage = addErrorMessage

    function removeErrorMessage(target){
      if (!target || !target.length) { return }

      var $formGroup = target.closest('.form-group');

      target.removeClass('has-error')
      $formGroup.removeClass('has-error')
      $formGroup.find('.error_message').remove();

      syncAddressLabelErrorState()
    }
    window.removeErrorMessage = removeErrorMessage

    function overCharaLength(str, maxLength){
      if (str === undefined || str === null) { str = '' }
      if (typeof maxLength !== 'number') { return false }
      return String(str).length > maxLength
    }
    window.overCharaLength = overCharaLength

    // TODO使用してはいけない文字を含んでいないかチェックする
    function includeUnusableCharacters(str){
      if (str === undefined || str === null) { return false }
      str = String(str)
      if (str === '') { return false }

      for (var i = 0; i < UnusableCharacters.length; i++) {
        if (str.includes(UnusableCharacters[i])) {
          return true
        }
      }
      return false
    }
    window.includeUnusableCharacters = includeUnusableCharacters

    function validateShiftJisForm(target, maxLength, options){
      var value = target.val() || ''
      var opts = {}

      if (typeof options === 'boolean') {
        opts.is_required = options
      } else if (typeof options === 'object' && options !== null) {
        opts = options
      }

      var length = opts.useBytes ? calculateShiftJisBytes(value) : value.length

      if (value === '') {
        removeErrorMessage(target)
      } else {
        if (typeof maxLength === 'number' && length > maxLength) {
          addErrorMessage(target, '入力した文字が長すぎます。')
        } else if (includeUnusableCharacters(value)) {
          addErrorMessage(target, '入力した文字は使用できません。')
        } else {
          removeErrorMessage(target)
        }
      }

      submittableSaveButton()
    }

    // 商品選択「長さ」フォームバリデーション
    function validateNumericLengthForm(target, maxLength){
      if (target.val() == '') {
        removeErrorMessage(target)
      }else if (target.val() > Number($('#selected-steel-pipe-max-length').val())){
        addErrorMessage(target, 'ご指定いただけません。')
      }else if (typeof maxLength === 'number' && target.val().length > maxLength) {
        addErrorMessage(target, '入力した文字が長すぎます。')
      }else if (includeUnusableCharacters(target.val())) {
        addErrorMessage(target, '入力した文字は使用できません。')
      }else if (!isNumeric(target.val()) && target.val().slice(-1) !== '.'){
        addErrorMessage(target, '数値を入力してください。')
      }
      else {
        removeErrorMessage(target)
      }

      submittableSaveButton()
    }
    window.validateNumericLengthForm = validateNumericLengthForm

    function isNumeric(char){
      const integerRegex = /^-?\d+$/;
      const decimalRegex = /^-?\d+(\.\d+)?$/;

      return integerRegex.test(char) || decimalRegex.test(char);
    }
    window.isNumeric = isNumeric

    // 基幹システム側のSJIS制御文字(Shift-In/Shift-Out)挿入ルールを考慮したバイト数計算
    function calculateShiftJisBytes(value){
      if (!value) {
        return 0
      }

      var total = 0
      var inDoubleByteBlock = false

      for (var i = 0; i < value.length; i += 1) {
        var char = value.charAt(i)
        var isDoubleByte = isShiftJisDoubleByteCharacter(char)

        if (isDoubleByte) {
          if (!inDoubleByteBlock) {
            total += 1 // Shift-In
            inDoubleByteBlock = true
          }
          total += 2 // SJIS 2byte 本体
        } else {
          if (inDoubleByteBlock) {
            total += 1 // Shift-Out
            inDoubleByteBlock = false
          }
          total += 1 // SJIS 1byte 文字
        }
      }

      if (inDoubleByteBlock) {
        total += 1 // 末尾の Shift-Out
      }

      return total
    }

    // SJISで2byte扱いとなる文字の判定
    function isShiftJisDoubleByteCharacter(char){
      if (!char) {
        return false
      }

      if (/^[\u0000-\u007F]$/.test(char)) {
        return false
      }

      if (/^[\uFF61-\uFF9F]$/.test(char)) {
        return false
      }

      return true
    }

    // 半角文字であるかをチェックし、半角文字以外を削除する
    function checkHalfWidthChar(target) {
      value = target.val()
      if (value.match(/[^a-zA-Z0-9]+/)) {
        value = value.replace(/[^a-zA-Z0-9]+/, "");
      }
      target.val(value);
    }

// ==================共通バリデーションで使用する関数終わり================================

    initForm()
    initToolTips()
    window.changeSearchStockButtonDisabled()
    setAccordionIconAnimation()
    getMaintenanceStatus()
    setMaintenanceToolTip()
  }
});
